import { useQuery } from '@tanstack/react-query';
import { fetchExamCourseCategories } from '../services/examCategoryService';

export function useExamCourseCategories(examsId, enabled = false) {
  return useQuery({
    queryKey: ['examCourseCategories', Number(examsId)],
    queryFn: () => fetchExamCourseCategories(Number(examsId)),
    enabled: enabled && Number(examsId) > 0,
    staleTime: 5 * 60 * 1000,
    retry: 2,
  });
}
